const INPUT = {
  MIN_SUGGESTION_STRING_LENGTH: 3,
};

export { INPUT };
